import { Col, Row } from 'antd'
import { automationFactory } from '../../factories/AutomationFactory'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectSelectedProfile } from '../../store/ProfileReducer'
import { useNavigate } from 'react-router-dom'

const AutomationsPage = () => {
  const dispatch = useAppDispatch()
  const automation = automationFactory.build()
  const profile = useAppSelector(selectSelectedProfile())
  const navigate = useNavigate()

  useEffect(() => {
    if (profile?.automations && profile?.automations.length === 1) {
      navigate(`${profile?.automations[0]}`)
    }
  }, [])

  return (
    <Row gutter={[16, 26]}>
      <Col span={24}></Col>
    </Row>
  )
}

export default AutomationsPage
